<template>
  <v-dialog v-model="dialog" persistent no-scrollable max-width="700px">
    <v-card>
      <v-card-title class="pa-0">
        <v-col class="text-end py-0 px-0" cols="12">
          <v-btn class="pa-0" icon dark @click="close()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0" cols="12">
          <!-- <v-icon color="error" class="mb-1 mr-2">fa-exclamation-circle</v-icon> -->
          <span class="title pt-5" color="error">Falha ao tentar enviar o anexo</span><br>
          {{info.arq_nome}}
        </v-col>
        <v-col class="text-left pt-0 px-9" cols="12">
          <v-alert dense text type="error" icon="fa fa-exclamation-circle" width="100%">
            <template v-if="info.erro_tipo == 2">
              <p><small>Falha ao tentar se autenticar.</small><br> 
                     Verifique se os dados de login e senha cadastrados estão válidos.<br>
                     Após a atualização da senha, os processos serão retomados automaticamente.</p>
            </template>
            <template v-else-if="info.erro_tipo == 1">
              <small>Entre em contato com o administrador do sistema.</small>
              <br>{{info.erro_mensagem}}
            </template>
             <template v-else-if="info.erro_tipo == 3">
              <small>Possível instabilidade da operadora.</small><br> {{info.erro_mensagem}}
            </template>
            <template v-else-if="info.erro_interno && info.erro_tipo == 0">
              <small>Erro interno. Entre em contato com o administrador do sistema.</small><br> 
              {{info.erro_mensagem}}
            </template>
            <template v-else>
              <small>Mensagem da operadora:</small><br> {{info.mensagens}}
            </template>
          </v-alert>
        </v-col>
        <v-row  wrap class="px-7 ma-0">
          <v-col class="text-left py-0" cols="6">
            <span class="card-title-form-guia textsRec" style="display: block">Número do Documento:</span>
            <span style="font-size:16px;font-weight:bold;">{{info.numero_documento}}</span>
          </v-col>
          <v-col class="text-left py-0" cols="3">
            <span class="card-title-form-guia textsRec" style="display: block">Número do lote: </span>
            <span style="font-size:16px;font-weight:bold;">{{ info.numero_lote }}</span>
          </v-col>
          <v-col class="text-left py-0" cols="3">
            <span class="card-title-form-guia textsRec" style="display: block">Número da guia: </span>
            <span style="font-size:16px;font-weight:bold; color: green">{{ info.numero_guia }}</span>
          </v-col>
          <!-- <v-col class="text-left pb-4 pt-0" cols="3">
            <span class="card-title-form-guia textsRec" style="display: block">Valor Acatado (R$): </span>
            <span style="font-size:16px;font-weight:bold; color: red">{{ info.valor_acatado| formatPrice }}</span>
          </v-col> -->
        </v-row>
      </v-card-title>
      <v-card-text v-if="enableProtocolo" class="px-10 pt-0 pb-0">
        <v-divider class="pt-2 mx-0 mt-2"></v-divider>
         <v-col class="text-center pt-0 pl-2" cols="12">
            <span class="title py-5" color="error">Registrar Protocolo manualmente</span>
         </v-col>
        <v-form ref="protocoloAnexoRecursoErroForm" :value="formValid">
          <v-row>
          <v-col class="py-0 px-3 ma-0" cols="6">
            <label style="margin-bottom: 2px">Data do envio</label>
            <v-menu
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  dense
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="formData.data_envio = parseDate(dateFormatted)"
                  :rules="[formRules.requiredField, formRules.typeDateFormated]"
                ></v-text-field>
                  <!-- :rules="formRules.required" -->
              </template>
              <v-date-picker
                color="primary"
                v-model="formData.data_envio"
                @input="dateFormatted = formatDate(formData.data_envio)"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-3 ma-0" cols="6">
            <label>Número do protocolo</label>
             <v-text-field
              v-model="formData.protocolo_envio"
              small
              height="30px"
              placeholder="Protocolo de envio"
              single-line
              outlined
              dense
              :rules="[formRules.requiredField, formRules.max20]"
            ></v-text-field>
          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-6 pb-1 pt-2">
        <v-col class="text-left px-4 pb-4 pt-0" cols="3">
          <v-btn
            height="30px"
            small
            color="primary"
            depressed
            outlined
            @click="close()"
          >
            Fechar
          </v-btn>
        </v-col>
        <v-col class="text-right pl-5 pr-3 pb-6 pt-0" cols="9" v-if="info.erro_tipo!=1 && info.erro_tipo!=2 && (info.status_envio == -1 || info.critica_ignorada)">
            <v-btn
           v-if="info.erro_tipo == 3 && !enableProtocolo" 
            height="30px"
            class="mr-3"
            small
            color="primary"
            outlined
            @click="ReenvioDeAnexo()"
          >
            Tentar enviar novamente
          </v-btn>
           <v-btn
           v-if="!enableProtocolo" 
            height="30px"
            class="mr-3"
            small
            color="error"
            outlined
            @click="enableProtocolo = true"
          > <!--depressed-->
            Ignorar erro manualmente
          </v-btn>
          <v-btn v-if="enableProtocolo" 
            class="mr-3" 
            color="primary" 
            height="30px" 
            small 
            depressed 
            @click="save()">
            Salvar
          </v-btn>
        </v-col> 
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
// import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      formData: {
        recurso_anexos_id: null,
        recurso_lote_id: null,
        data_envio: null,
        protocolo_envio: null
      },
      dateFormatted: null,
      enableProtocolo: false,
      formValid: true,
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.clean();
      } else {
        this.formData = Object.assign(this.formData)
        this.formData.recurso_anexos_id = this.info.id;
        this.formData.recurso_lote_id = this.info.recurso_lote_id;
        this.dateFormatted = this.formatDate(this.info.data_hora_envio);
        this.formData.protocolo_envio = this.info.numero_protocolo_envio;
      }
    },
    dateFormatted(val) {
      this.formData.data_envio = this.parseDate(val);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    clean() {
      this.enableProtocolo = false;
      if(this.$refs.protocoloAnexoRecursoErroForm){
        this.$refs.protocoloAnexoRecursoErroForm.reset();
        this.$refs.protocoloAnexoRecursoErroForm.resetValidation();
      }
    },
    save() {
      if (this.$refs.protocoloAnexoRecursoErroForm.validate()) {
        let {prestador_id, operadora_ans_id, data_pagamento, id} = this.dadosPagamento
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "AddProtocoloAnexoRecurso",
              payload: {
                data_pagamento,
                grupo_economico: this.grupoEconomico,
                operadora_ans_id,
                pagamento_id: id,
                prestador_id,
                critica_ignorada: true,
                protocolos:[{...this.formData}]
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> { this.clean(); this.close(); this.updatePage()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false },
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
      }
    },
    DeleteProtocoloConfirm(){
        let paramModal = {
          type: "warning",
          title: "Exclusão de protocolo",
          message: "Deseja realmente excluir este protocolo?",
          callback: () => this.DeleteProtocolo(),
          btConfirm: { name: "Excluir", show: true, color: 'warning'},
          btCancel: { name: "Não", show: true },
        };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);  

    },
     DeleteProtocolo(){
        let {prestador_id, operadora_ans_id, data_pagamento, pagamento_id} = this.info
        console.log(pagamento_id)
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "AddProtocoloLotesRecursados",
              payload: {
                data_pagamento,
                grupo_economico: this.grupoEconomico,
                operadora_ans_id,
                pagamento_id,
                prestador_id,  
                protocolos:[{lote_id: null, data_envio: null, protocolo_envio: null}]
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> { this.clean(); close(); this.updatePage()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false },
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });

     },
      ReenvioDeAnexo(){
        let {pagamento_id, id, recurso_lote_id} = this.info
        let _this = this
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "reenviodeanexo",
              payload: {
                grupo_economico: this.grupoEconomico,
                recurso_anexos_id: id,
                recurso_lote_id: recurso_lote_id, 
                pagamento_id
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> { _this.clean(); _this.close(); _this.updatePage()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false }
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
     }
  },
  props: {
    close: Function,
    dadosPagamento: Object,
    dialog: Boolean,
    grupoEconomico: Number,
    info: Object,
    updatePage: Function,
    finalizaEnvio: Boolean
  },
};
</script>

<style>
.button-histor:focus {
  outline: none;
}
.card-title-form-guia {
  font-size: 0.90rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
.textsRec {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
</style>